import { render, staticRenderFns } from "./menu-pauta.vue?vue&type=template&id=44e11f68&"
import script from "./menu-pauta.vue?vue&type=script&lang=js&"
export * from "./menu-pauta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports